import React from "react";

export default function UserNot() {
    return (
        <div className="bg-black p-4 font-sans text-[13px] leading-tight text-black">
            <div className="max-w-[1200px] mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                <div className="space-y-6">
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-green-100 w-10 relative rounded-l">
                            <div className="text-green-600 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-green-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Thank You!
                            </p>
                            <p className="text-[13px] leading-tight">
                                Funding Successful!
                            </p>
                            <p className="text-[13px] font-bold text-green-700 mt-1 cursor-pointer">
                                Review Funding Details
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                It’s awkward
                                <span>
                                    😅
                                </span>
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                We were unable to process payment for your funding.
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Try Again?
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Insufficient Funds
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Transaction declined due to insufficient funds.
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Change Funding Source
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Transaction Error
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                An error occurred during the transaction. Please try again.
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Try again?
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-purple-200 w-10 relative rounded-l">
                            <div className="text-purple-600 text-xs font-bold">
                                <i className="fas fa-coins">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-black/10 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                You Earned IOU Points!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Yehey some text here!
                            </p>
                            <p className="text-[13px] font-bold text-purple-600 mt-1 cursor-pointer">
                                Check IOU Points Balance
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-green-100 w-10 relative rounded-l">
                            <div className="text-green-600 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-green-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Points Redemption Successful!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Points redeemed successfully.
                            </p>
                            <p className="text-[13px] font-bold text-green-700 mt-1 cursor-pointer">
                                Check More Rewards
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Points Redemption Failed!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Points redemption failed.
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Try Again?
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                </div>
                <div className="space-y-6">
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-green-100 w-10 relative rounded-l">
                            <div className="text-green-600 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-green-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Thank You!
                            </p>
                            <p className="text-[13px] leading-tight">
                                Repayment Successful!
                            </p>
                            <p className="text-[13px] font-bold text-green-700 mt-1 cursor-pointer">
                                Review Repayment Details
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-blue-200 w-10 relative rounded-l">
                            <div className="text-blue-600 text-xs font-bold">
                                <i className="fas fa-wifi">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-blue-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Verification Successful
                            </p>
                            <p className="text-[13px] leading-tight">
                                Congratulations for Verifying.
                            </p>
                            <p className="text-[13px] font-bold text-blue-700 mt-1 cursor-pointer">
                                Continue Loan Request
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-blue-600 w-10 relative rounded-l">
                            <div className="text-white text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-blue-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Loan Request Created!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Yehey some text here!
                            </p>
                            <p className="text-[13px] font-bold text-blue-700 mt-1 cursor-pointer">
                                View Active Loans
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Server Error!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Sorry some text here!
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Try Again?
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                It’s awkward
                                <span>
                                    😅
                                </span>
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                We were unable to process your loan request.
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Try Again?
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px] relative">
                        <div className="flex flex-col justify-center items-center bg-purple-400 w-10 rounded-l">
                            <div className="text-white text-xs font-bold">
                                <i className="fas fa-crown">
                                </i>
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight flex items-center gap-1">
                                <span>
                                    Congratulations!
                                </span>
                                <img alt="Pink star icon" height="12" src="https://storage.googleapis.com/a1aa/image/2e50bad2-1de5-481c-f6c9-f5028f6933f8.jpg" width="12" />
                                <img alt="Purple star icon" height="12" src="https://storage.googleapis.com/a1aa/image/41bb9594-1f03-42e1-0226-bfa93ca45a19.jpg" width="12" />
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Your Maximum Credit Limit increased!
                            </p>
                            <p className="text-[13px] font-bold text-purple-600 mt-1 cursor-pointer">
                                Check Credit Limit
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700 absolute top-2 right-2">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                </div>
                <div className="space-y-6">
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-gray-300 w-10 relative rounded-l">
                            <div className="text-gray-600 text-xs font-bold">
                                <i className="fas fa-wifi">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-black/10 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Network Error!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Please check your Internet Connection
                            </p>
                            <p className="text-[13px] font-bold text-gray-400 mt-1 cursor-pointer">
                                Try Again?
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-cyan-300 w-10 relative rounded-l">
                            <div className="text-cyan-700 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-cyan-700 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Profile Updated!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Yehey some text here!
                            </p>
                            <p className="text-[13px] font-bold text-cyan-700 mt-1 cursor-pointer">
                                View Profile Details
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-blue-200 w-10 relative rounded-l">
                            <div className="text-blue-600 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-blue-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Verification Successful!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Your account has been verified.
                            </p>
                            <p className="text-[13px] font-bold text-blue-700 mt-1 cursor-pointer">
                                Check Loan Benefits
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-lock">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Verification Failed!
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Account verification failed. Please try again.
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Try Again?
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-100 w-10 relative rounded-l">
                            <div className="text-pink-500 text-xs font-bold">
                                <i className="fas fa-lock">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-500 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                We’ve noticed something unusual.
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Your account is paused for now! Please contact our friendly support team!
                            </p>
                            <p className="text-[13px] font-bold text-pink-500 mt-1 cursor-pointer">
                                Contact Support
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                </div>
                <div className="space-y-6">
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-200 w-10 relative rounded-l">
                            <div className="text-pink-600 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Alert Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-pink-200 w-10 relative rounded-l">
                            <div className="text-pink-600 text-xs font-bold">
                                <i className="fas fa-times-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-pink-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Alert Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                            <p className="text-[13px] font-bold text-pink-600 mt-1 cursor-pointer">
                                Button
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-yellow-200 w-10 relative rounded-l">
                            <div className="text-yellow-600 text-xs font-bold">
                                <i className="fas fa-exclamation-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-yellow-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Caution Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-yellow-200 w-10 relative rounded-l">
                            <div className="text-yellow-600 text-xs font-bold">
                                <i className="fas fa-exclamation-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-yellow-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Caution Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                            <p className="text-[13px] font-bold text-yellow-600 mt-1 cursor-pointer">
                                Button
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-green-200 w-10 relative rounded-l">
                            <div className="text-green-600 text-xs font-bold">
                                <i className="fas fa-check-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-green-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Success Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-green-200 w-10 relative rounded-l">
                            <div className="text-green-600 text-xs font-bold">
                                <i className="fas fa-check-circle">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-green-600 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Success Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                            <p className="text-[13px] font-bold text-green-600 mt-1 cursor-pointer">
                                Button
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-purple-200 w-10 relative rounded-l">
                            <div className="text-purple-600 text-xs font-bold">
                                <i className="fas fa-comment-alt">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-black/10 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Info Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                    <div className="flex shadow-custom rounded border border-gray-200 bg-white max-w-[320px]">
                        <div className="flex flex-col justify-center items-center bg-purple-200 w-10 relative rounded-l">
                            <div className="text-purple-600 text-xs font-bold">
                                <i className="fas fa-comment-alt">
                                </i>
                            </div>
                            <div className="absolute -right-1 top-1 w-5 h-5 rounded-full bg-black/10 flex items-center justify-center text-white text-[10px] font-bold">
                                x
                            </div>
                        </div>
                        <div className="p-4 flex-1">
                            <p className="font-extrabold text-[13px] leading-tight">
                                Cooler Info Snackbar
                            </p>
                            <p className="text-[13px] leading-tight font-normal">
                                Some important information will appear here
                            </p>
                            <p className="text-[13px] font-bold text-purple-600 mt-1 cursor-pointer">
                                Button
                            </p>
                        </div>
                        <button aria-label="Close" className="p-4 text-black hover:text-gray-700">
                            <i className="fas fa-times">
                            </i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
